import { PaymentPricing } from '@/types/payment-account';
import { formatCardBrands } from './shared';

/** Textos do checkout automático do cliente (plano, seção 6.7 e 5.1 — `/checkout/:id`). */

export const CHECKOUT_PIX = {
  waitingTitle: 'Estamos esperando seu pagamento',
  expiredButton: 'Gerar novo código',
};

export function getCheckoutCardBrandsNotice(pricing: PaymentPricing): string {
  return `Aceitamos ${formatCardBrands(pricing.cardBrands)}.`;
}

export const CHECKOUT_BOLETO = {
  compensationNotice: 'Compensa em até 2 dias úteis.',
  requiresDocumentNotice:
    'O boleto exige CPF e endereço — já preenchemos o que você já nos passou.',
};

/** A T0.2 confirmou que aparece EBANX no extrato de conta BR (seção 6.7): aviso fixo na tela. */
export const CHECKOUT_EBANX_NOTICE = 'No seu extrato vai aparecer EBANX, parceiro de pagamentos.';
